import { FC } from "react"
import { PageId } from "../../common/pageId"
import { routeMap } from "../../components/generic/navbar/routeMap"

import { PageTemplate } from "../../components/pageTemplate/PageTemplate"
import { SidebarPageContent } from "../../components/SidebarPageContent"
import { Link } from "react-router-dom"
import { NavHashLink } from "react-router-hash-link"

import { PageContent } from "../../common/pageText"

export const FAQ: FC = () => {
  return (
    <PageTemplate
      pageTitle="Frequently Asked Questions"
      pageContentClassName="info-page-container"
    >
      <SidebarPageContent
        route={routeMap[PageId.FAQS]}
        sectionClassName="faq-section"
        sidebarItems={[
          {
            id: "GeneralQuestions",
            header: "General Questions",
            body: (
              <div className="faq-questions">
                <div className="faq-question">
                  <header className="faq-queastion-header">What is OCS?</header>
                  <p>
                    OCS is a web based system developed to allow registered
                    users to view and download schedules for selected airports.
                    Additionally users are able to add, change or delete slots
                    from their own portfolio at any of these airports. Users are
                    not permitted to amend other air carriers’ slots unless they
                    have been given permission by these carriers.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    What are the benefits of registering as a user of OCS?
                  </header>
                  <p>
                    OCS provides a simple and efficient tool for an air carrier
                    to view and manage (add, change and delete) their slots as
                    they require.
                  </p>
                  <p>OCS provides real time responses to slot requests.</p>
                  <p>
                    OCS eliminates the need for SITA messages to the Coordinator
                    saving time and message costs.
                  </p>
                  <p>OCS enables airlines to evaluate ‘what if’ scenarios.</p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Which airports are accessible within Online Coordination?
                  </header>
                  <p>
                    A list of the countries and airports available on OCS can be
                    viewed by visiting the Runway Availability pages.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    What schedule data can I see if I register as a user of OCS?
                  </header>
                  <p>
                    Registered users can view the entire schedule for any
                    selected airport as well as being able to add, change or
                    delete slots from their own portfolio. They are allowed to
                    view the schedules of all other air carriers but not to
                    amend other air carrier’s slots unless they have been given
                    permission by these carriers.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Can I edit my slot portfolio online?
                  </header>
                  <p>
                    OCS provides online tools for the registered user to request
                    new slots, as well as amend and delete existing slots.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Who can view my schedules using OCS?
                  </header>
                  <p>
                    Any registered user of OCS can view the whole schedule for
                    any airport but cannot amend other operators’ schedules
                    unless they have ben given permission by these carriers.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Who can apply for an OCS User ID?
                  </header>
                  <p>
                    Any air carrier with a valid operating license can apply to
                    use OCS.
                  </p>
                  <p>
                    Applications must be submitted by the Authorised
                    Representative (SSIM Manual Attachment 2) of an air carrier.
                  </p>
                  <p>
                    Handling Agents representing General/Business Aviation
                    operators can also register to use OCS.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    How much does it cost to register to use OCS?
                  </header>
                  <p>
                    Registration for OCS costs €450 per annum for up to two
                    accounts. If you require additional accounts for staff who
                    work for your Company then these cost €60 per annum for each
                    additional account. These charges are designed to cover the
                    cost of security and password administration by the OCS
                    Portal Administrator.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Do I get preferential treatment or higher priority for slots
                    if I use the OCS system?
                  </header>
                  <p>
                    No, OCS uses the same rules and priorities for the
                    allocation of slots as those used by the coordinators when
                    they manually allocate slots. There is no preferential
                    treatment or higher priority for slot allocation gained by
                    using OCS.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    How do I know that OCS is secure?
                  </header>
                  <p>
                    OCS has been designed from the outset to provide a totally
                    secure means of Authorised Users, or their representatives,
                    being able to add, change and delete slots in their own
                    portfolio.
                  </p>
                  <p>
                    The technologies used are the same as those that have been
                    used by the banking industry to ensure security and privacy
                    of their user accounts for many years.
                  </p>
                  <p>
                    In addition tools to monitor, on a continuous basis,
                    activity by users on OCS have been developed and there are
                    regular reports that will identify any attempted breaches of
                    security.
                  </p>
                </div>
              </div>
            )
          },
          {
            id: "howToApply",
            header: "How To Apply",
            body: (
              <div className="faq-questions">
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    How do I apply for an OCS User ID?
                  </header>
                  <p>
                    To apply for an OCS account you must complete the Account
                    Application Form which is available from this site.{" "}
                    <NavHashLink to={routeMap[PageId.HowToApply] + "#apply"}>
                      Please click here for more information
                    </NavHashLink>
                    .
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Once I have registered how long will it be before I can use
                    the system?
                  </header>
                  <p>
                    The registration process takes a maximum of one week as the
                    OCS Portal Administrator verifies the authority of the
                    applicant to add, change and delete slots on behalf of their
                    Company.
                  </p>
                </div>
              </div>
            )
          },
          {
            id: "systemFunctionality",
            header: "Functionality of the System",
            body: (
              <div className="faq-questions">
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Can I find out about Slot Availability at an airport?
                  </header>
                  <p>
                    OCS provides pages showing details of{" "}
                    <Link to={"/" + PageId.AvailWeek}>Slot Availability</Link>{" "}
                    for each airport and can be viewed by anyone without
                    registering as a user of OCS.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    What is slot availability?
                  </header>
                  <p>
                    The{" "}
                    <Link to={"/" + PageId.AvailWeek}>Slot Availability</Link>{" "}
                    displays show all the available runway slots for each hour
                    that have not yet been allocated to air carriers. There are
                    selections to enable users to view availability for all
                    hours on a single day, all weeks in the season for a single
                    hour. The runway Slot Availability can be viewed by anyone,
                    not just registered users. There are also displays of
                    terminal capacity availability for certain airports.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    What slot allocation rules are used by OCS?
                  </header>
                  <p>
                    OCS uses the same Industry Standard allocation rules as
                    those used by the Coordinator when they manually allocate
                    slots.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    If I change my schedule using OCS will I get a confirmation
                    of my slot changes?
                  </header>
                  <p>
                    A confirmation email will be generated by the system in SCR
                    format that will include the submission and the response by
                    the system. The email address used will be that nominated by
                    the user at the time of registration to use Online
                    Coordination.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    What other functionality is available via OCS?
                  </header>
                  <p className="m-0 bold">Slot Monitoring</p>
                  <p>
                    Users of OCS can download a file containing the current slot
                    performance against the use-it-or-lose-it rules of the
                    customers' own flights at specified airports.
                  </p>
                  <p className="m-0 bold">Reporting</p>
                  <p>
                    OCS enables users to interrogate the coodinators' database
                    with a series of query statements to obtain simple or
                    complex reports on schedule data held in the database.
                  </p>
                </div>
              </div>
            )
          },
          {
            id: "technicalQuestions",
            header: "Technical Questions",
            body: (
              <div className="faq-questions">
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    What is the minimum PC specification required to run OCS?
                  </header>
                  <p>
                    We recommend the specification in the{" "}
                    <NavHashLink
                      to={
                        routeMap[PageId.HowToApply] + "#technicalRequirements"
                      }
                    >
                      Technical Requirements
                    </NavHashLink>{" "}
                    page when using OCS. Although OCS may run on PCs with a
                    lower specification, no support will be provided in these
                    instances.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Can I access OCS from more than one computer?
                  </header>
                  <p>
                    OCS can be accessed from any computer connected to the
                    internet and meeting the required specification. However
                    only one session at a time is permitted for any individual
                    user.
                  </p>
                </div>
              </div>
            )
          },
          {
            id: "support",
            header: "Help & Support",
            body: (
              <div className="faq-questions">
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    What do I do if I forget my password or pass code?
                  </header>
                  <p>
                    Should you forget your password or pass code, please contact
                    the Customer Service Centre who will be able to reset them.
                    Please note that the CSC will need to verify who you are
                    before they are able to change your details. For information
                    on contacting the CSC, please click{" "}
                    <Link to={routeMap[PageId.ContactUs]}>here</Link>.
                  </p>
                </div>
                <div className="faq-question">
                  <header className="faq-queastion-header">
                    Who do I contact if I have a question or a problem?
                  </header>
                  <p>
                    The{" "}
                    <Link to={routeMap[PageId.ContactUs]}>
                      {PageContent.contactUs}
                    </Link>{" "}
                    link provides an email form to contact the OCS Portal
                    Administrator as well as a phone number to contact the
                    Customer Service Centre. The Customer Service Centre
                    operates between 0800 and 1800 UK local time. .
                  </p>
                </div>
              </div>
            )
          }
        ]}
      />
    </PageTemplate>
  )
}
